/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Player,
  PlayerCreateRequest,
  PlayerTeamAssignmentRequest,
  PlayerUpdateRequest,
  RemovePlayerFromTeamRequest,
  UserPlayer,
} from '../models/index';
import {
    PlayerFromJSON,
    PlayerToJSON,
    PlayerCreateRequestFromJSON,
    PlayerCreateRequestToJSON,
    PlayerTeamAssignmentRequestFromJSON,
    PlayerTeamAssignmentRequestToJSON,
    PlayerUpdateRequestFromJSON,
    PlayerUpdateRequestToJSON,
    RemovePlayerFromTeamRequestFromJSON,
    RemovePlayerFromTeamRequestToJSON,
    UserPlayerFromJSON,
    UserPlayerToJSON,
} from '../models/index';

export interface AssignPlayerToTeamRequest {
    id: string;
    playerTeamAssignmentRequest: PlayerTeamAssignmentRequest;
}

export interface CreatePlayerRequest {
    playerCreateRequest: PlayerCreateRequest;
}

export interface DeletePlayerRequest {
    id: string;
}

export interface GetPlayerByIdRequest {
    id: string;
}

export interface GetUserPlayersRequest {
    email: string;
}

export interface RemovePlayerFromTeamOperationRequest {
    id: string;
    removePlayerFromTeamRequest: RemovePlayerFromTeamRequest;
}

export interface UpdatePlayerRequest {
    id: string;
    playerUpdateRequest: PlayerUpdateRequest;
}

/**
 * PlayerApi - interface
 * 
 * @export
 * @interface PlayerApiInterface
 */
export interface PlayerApiInterface {
    /**
     * 
     * @summary Assign a player to a team
     * @param {string} id 
     * @param {PlayerTeamAssignmentRequest} playerTeamAssignmentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    assignPlayerToTeamRaw(requestParameters: AssignPlayerToTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>>;

    /**
     * Assign a player to a team
     */
    assignPlayerToTeam(requestParameters: AssignPlayerToTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player>;

    /**
     * 
     * @summary Create a new player (not yet assigned to a team)
     * @param {PlayerCreateRequest} playerCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    createPlayerRaw(requestParameters: CreatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>>;

    /**
     * Create a new player (not yet assigned to a team)
     */
    createPlayer(requestParameters: CreatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player>;

    /**
     * 
     * @summary Delete a player (only if not assigned to any team)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    deletePlayerRaw(requestParameters: DeletePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a player (only if not assigned to any team)
     */
    deletePlayer(requestParameters: DeletePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get player details by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    getPlayerByIdRaw(requestParameters: GetPlayerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>>;

    /**
     * Get player details by ID
     */
    getPlayerById(requestParameters: GetPlayerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player>;

    /**
     * 
     * @summary Get all players created by user (across all teams)
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    getUserPlayersRaw(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserPlayer>>>;

    /**
     * Get all players created by user (across all teams)
     */
    getUserPlayers(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserPlayer>>;

    /**
     * 
     * @summary Remove a player from their current team
     * @param {string} id 
     * @param {RemovePlayerFromTeamRequest} removePlayerFromTeamRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    removePlayerFromTeamRaw(requestParameters: RemovePlayerFromTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a player from their current team
     */
    removePlayerFromTeam(requestParameters: RemovePlayerFromTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Update player details
     * @param {string} id 
     * @param {PlayerUpdateRequest} playerUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlayerApiInterface
     */
    updatePlayerRaw(requestParameters: UpdatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>>;

    /**
     * Update player details
     */
    updatePlayer(requestParameters: UpdatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player>;

}

/**
 * 
 */
export class PlayerApi extends runtime.BaseAPI implements PlayerApiInterface {

    /**
     * Assign a player to a team
     */
    async assignPlayerToTeamRaw(requestParameters: AssignPlayerToTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling assignPlayerToTeam.');
        }

        if (requestParameters.playerTeamAssignmentRequest === null || requestParameters.playerTeamAssignmentRequest === undefined) {
            throw new runtime.RequiredError('playerTeamAssignmentRequest','Required parameter requestParameters.playerTeamAssignmentRequest was null or undefined when calling assignPlayerToTeam.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/players/{id}/assign-team`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlayerTeamAssignmentRequestToJSON(requestParameters.playerTeamAssignmentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerFromJSON(jsonValue));
    }

    /**
     * Assign a player to a team
     */
    async assignPlayerToTeam(requestParameters: AssignPlayerToTeamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
        const response = await this.assignPlayerToTeamRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new player (not yet assigned to a team)
     */
    async createPlayerRaw(requestParameters: CreatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
        if (requestParameters.playerCreateRequest === null || requestParameters.playerCreateRequest === undefined) {
            throw new runtime.RequiredError('playerCreateRequest','Required parameter requestParameters.playerCreateRequest was null or undefined when calling createPlayer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/players`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PlayerCreateRequestToJSON(requestParameters.playerCreateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerFromJSON(jsonValue));
    }

    /**
     * Create a new player (not yet assigned to a team)
     */
    async createPlayer(requestParameters: CreatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
        const response = await this.createPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a player (only if not assigned to any team)
     */
    async deletePlayerRaw(requestParameters: DeletePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deletePlayer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/players/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a player (only if not assigned to any team)
     */
    async deletePlayer(requestParameters: DeletePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deletePlayerRaw(requestParameters, initOverrides);
    }

    /**
     * Get player details by ID
     */
    async getPlayerByIdRaw(requestParameters: GetPlayerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getPlayerById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/players/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerFromJSON(jsonValue));
    }

    /**
     * Get player details by ID
     */
    async getPlayerById(requestParameters: GetPlayerByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
        const response = await this.getPlayerByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all players created by user (across all teams)
     */
    async getUserPlayersRaw(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserPlayer>>> {
        if (requestParameters.email === null || requestParameters.email === undefined) {
            throw new runtime.RequiredError('email','Required parameter requestParameters.email was null or undefined when calling getUserPlayers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/users/{email}/players`.replace(`{${"email"}}`, encodeURIComponent(String(requestParameters.email))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserPlayerFromJSON));
    }

    /**
     * Get all players created by user (across all teams)
     */
    async getUserPlayers(requestParameters: GetUserPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserPlayer>> {
        const response = await this.getUserPlayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a player from their current team
     */
    async removePlayerFromTeamRaw(requestParameters: RemovePlayerFromTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling removePlayerFromTeam.');
        }

        if (requestParameters.removePlayerFromTeamRequest === null || requestParameters.removePlayerFromTeamRequest === undefined) {
            throw new runtime.RequiredError('removePlayerFromTeamRequest','Required parameter requestParameters.removePlayerFromTeamRequest was null or undefined when calling removePlayerFromTeam.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/players/{id}/remove-from-team`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemovePlayerFromTeamRequestToJSON(requestParameters.removePlayerFromTeamRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a player from their current team
     */
    async removePlayerFromTeam(requestParameters: RemovePlayerFromTeamOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removePlayerFromTeamRaw(requestParameters, initOverrides);
    }

    /**
     * Update player details
     */
    async updatePlayerRaw(requestParameters: UpdatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updatePlayer.');
        }

        if (requestParameters.playerUpdateRequest === null || requestParameters.playerUpdateRequest === undefined) {
            throw new runtime.RequiredError('playerUpdateRequest','Required parameter requestParameters.playerUpdateRequest was null or undefined when calling updatePlayer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/players/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlayerUpdateRequestToJSON(requestParameters.playerUpdateRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerFromJSON(jsonValue));
    }

    /**
     * Update player details
     */
    async updatePlayer(requestParameters: UpdatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
        const response = await this.updatePlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
